export default {
  affiliate: {
    // Main navigation
    title: 'Affiliate',
    cantFindQuestion: "Can't find the question?",
    onlineService: 'Online Service',
    dashboard: 'Dashboard',
    myRewards: 'My Rewards',
    invitationRewards: 'Invitation Rewards',
    rules: 'Rules',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',

    // Team Info
    teamData: 'Team Data',
    details: 'Details',
    totalValidFriends: 'Total valid friends:',
    todayTotalWager: 'Today total wager:',
    rewards: 'Rewards',

    // Commission rates
    inviteFriendsCommissionUpTo: 'Invite Friends Commission Up To',
    expandTeamBonus: 'Expand Team Bonus',
    maxLevelCommission: 'Max Level Commission',
    inviteFriendsCommission: 'Invite Friends Commission',
    maxPerformanceCommission: 'Max Performance Commission',
    unlimitedAgent: 'Unlimited Agent',
    unlimitedCommission: 'Unlimited Commission',
    commissionRate: 'Commission Rate',

    // Team Invite Friends
    inviteFriendsToEarn: 'INVITE FRIENDS TO EARN',
    link: 'Link',
    code: 'Code',
    inviteFriends: 'Invite friends',
    share: 'Share',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'Claim',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'Today Received',

    // Live Rewards
    liveRewards: 'Live Rewards',
    sendTotalCommission: 'Send total commission',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'Today Invite Friends',
    todayDepositFriends: 'Today Deposit Friends',
    depositFriends: 'Deposit Friends',
    validFriends: 'Valid Friends',

    // Dialogs
    howMakeFriendsSubordinates: 'How to make friends your subordinates:',
    shareInvitationLink: 'Share your invitation link for them to register.',
    shareInvitationCode: 'Share your invitation code for them to enter during registration.',
    shareQRCode: 'Share your QR code for them to scan and register.',
    depositFriendsDescription: 'When your subordinate friends successfully deposit money, they will become depositing friends.',
    howMakeFriendsValidUsers: 'How to make your friends become valid users:',
    successfullyInviteFriends: 'Successfully invite friends to sign up.',
    cumulativeDepositsReach: 'Their cumulative deposits reach 10.00 USDT.',
    cumulativeValidBetsReach: 'Their cumulative valid bets reach 50.00 USDT.',
    thenBecomeValidUsers: 'Then, they will become valid users.',

    // Share Dialog
    shareTitle: 'Share',
    player: 'Player',
    saveImage: 'Save image',
    saveImageSuccess: "Image saved",
    saveImageFailed: "Save failed, please try again",
    copy: 'Copy',
    copied: 'Copied!',

    // Received/Withdraw
    received: 'Received',
    withdraw: 'Withdraw',
    history: 'History',
    referralRewards: 'Referral Rewards',
    commission: 'Commission',
    depositRebate: 'Deposit Rebate',
    levelUpRewards: 'Level Up Rewards',
    loading: 'Loading...',
    noMoreRecords: 'No more records',
    loadMore: 'Load more',
    pending: 'Pending',
    paid: 'Paid',
    rejected: 'Rejected',
    unknown: 'Unknown',
    upgradeReward: 'Upgrade Reward',
    cancelled: 'Cancelled',
    receiving: 'Receiving',
    failed: 'Failed',
    expired: 'Expired',

    // History Dialog
    pickDate: 'Pick a date',
    select: 'Select',
    chooseBonus: 'Choose bonus',
    all: 'All',

    // Invitation Rewards Page
    inviteFriendToGet: 'Invite a friend to get',
    yourFriendGet: 'Your friend get',
    inviteFriendsEarnRewards: 'Invite friends and earn rewards',
    dailyInvitations: 'Daily invitations',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'How to earn affiliate rewards?',
    shareToFriends: 'Share to friends',
    shareReferralLink: 'Share your referral link, code or QR code with your friends.',
    friendsSignUpDeposit: 'Friends sign up and deposit',
    inviteFriendsRegisterDeposit: 'Invite friends to register on AFUN and make a first deposit.',
    getUpTo: 'Get Up To',
    earnBigRewards: 'Earn rewards & commissions when friends bet, deposit, and reach VIP.',
    noticeEnsureCorrect: 'Notice: Ensure the invitation link, QR code, or code is correct.',

    // Rules - Commission Work
    howCommissionWork: 'How does Commission work?',
    agentRatingDescription: 'Agent Rating Description',
    you: 'YOU',
    commissionDescription: 'Earn a commission from the deposits and bets of your Friends B, C, D, and beyond. See the chart on the right for commission rates.',
    claimConditions: 'Claim conditions',
    teamLevel: 'Team Level',
    earnUpTo: "Earn up to",
    expandYourTeam: "Expand Your Team",
    earnAnExtra: "Earn an Extra",
    upgradeAgentLevel: "Upgrade Your Agent Level",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'Total Size',
    teamWager: 'Team Wager',
    rebateRewardVary: 'Rebate Reward & Top Up Reward vary based on your Team level on that day.',
    teamSizeDescription: 'Team size: The number of valid users you currently have.',
    teamBettingDescription: 'Team betting: The total number of bets your subordinates make in one day.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'TEAM COMMISSION',
    teamCommissionSubTitle: 'Earn from every deposit and\nevery bet across your network.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'Invite friends, and both will receive rewards',
    inviteRegisterReceive: 'Successfully invite friends to register and receive',
    friendDepositWagerUnlock: 'When your friend deposits 10.00 USDT and wagers 50.00 USDT, you unlock a 3.00 USDT reward, and your friend gets 2.00 USDT.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'Recent Invite Friends',
    recentDepositFriends: 'Recent Deposit Friends',
    today: 'Today',
    yesterday: 'Yesterday',
    thisMonth: 'This month',
    friendsData: 'Friends Data',
    joinDate: 'Join Date',
    search: 'Search',
    level: 'Level',
    tier: 'Tier',
    affiliateTreasureBox: 'Affiliate Treasure Box',
    referralRewardsDesc: 'When you invite friends to register, both you and your friends will receive generous bonuses.',
    commissionDesc: 'You and your team work together to achieve your goals and earn generous commissions.',
    affiliateTreasureBoxDesc: 'Invite friends to get milestone bonuses',
  }
};
